module.exports = __webpack_public_path__ + "static/logo-165a4baa777b1d89e2bcb676294ed44d.svg";